import { abujaImage1, abujaImage2, abujaImage3, abujaImage4, amenitiesIcon1, amenitiesIcon2, amenitiesIcon3, amenitiesIcon4, amenitiesImage, apartmentHeroImage, apartmentImage1, apartmentImage2, apartmentImage3, apartmentImage4, apartmentImage5, arenaImage, barbingImage, basicDeluxeImage, basicStandardImage, bodyTreatmentImage, bookingImage, bookingImage2, bookingImage3, cafeImage, cinemaImage, facialsImage, galleryHeroImage, gymCoupleImage, gymSingleImage, hairstylingImage, heroBg1, heroBg2, heroBg3, heroBg4, ikejaImage1, ikejaImage2, ikejaImage3, ikejaImage4, leftImage, luxuryDeluxeImage, luxuryRegularImage, luxuryStandardImage, makeupImage, massageImage, nailImage, ogunImage1, ogunImage2, ogunImage3, ogunImage4, rightImage, threeBedImage, twoBedImage, valueIcon1, valueIcon2, valueIcon3, valueIcon4 } from "../assets";

export const navLinks = [
  {
    id: 1,
    linkName: 'Home',
    linkRoute: "/",
  },
  {
    id: 2,
    linkName: 'About Us',
    linkRoute: "/about-us",
  },
  {
    id: 3,
    linkName: 'Apartments',
    sublinks: [
      {
        sublinkname: 'Lagos',
        sublinkroute: '/apartments/lagos',
        cs: false
      },
      {
        sublinkname: 'Ogun',
        sublinkroute: '/apartments/ogun',
        cs: false
      },
      {
        sublinkname: 'Abuja',
        sublinkroute: '/apartments/abuja',
        cs: false
      },
    ]
    // linkRoute: "/apartments",
  },  
  {
    id: 4,
    linkName: 'Things To Do',
    linkRoute: "/things-to-do",
  },  
];

export const footerLinks = [
  {
    id: 1,
    linkName: 'Home',
    linkRoute: "/",
  },
  {
    id: 2,
    linkName: 'About Us',
    linkRoute: "/about-us",
  },
  {
    id: 3,
    linkName: 'Apartments',
    linkRoute: "/apartments/lagos",
  },  
  {
    id: 4,
    linkName: 'Things To Do',
    linkRoute: "/things-to-do",
  },   
];

export const spaServices = [
  {
    id: 1,
    imagePicture: massageImage,
    hText: 'Massage',
    pTexts: ['Deep Tissue Massage (40 or 60 Minutes)', 'Energizing Massage (40 or 60 Minutes)', 'Relaxation Massage (40 or 60 Minutes)', 'Recovery Massage (40 or 60 Minutes)']
  },
  {
    id: 2,
    imagePicture: bodyTreatmentImage,
    hText: 'Body Treatment',
    pTexts: ['Body Polish', 'Body Detoxifying', 'Body Ultra-Hydrating']
  },
  {
    id: 3,
    imagePicture: facialsImage,
    hText: 'Facials',
    pTexts: ['Anti-Ageing Facial', 'Brightening Facial', 'Deep Cleansing Facial']
  },
];

export const salonServices = [
  {
    id: 1,
    imagePicture: hairstylingImage,
    hText: 'Hairstyling Service',
    pText: 'Multiple Options',
  },
  {
    id: 2,
    imagePicture: barbingImage,
    hText: 'Barbing Service',
    pText: 'Multiple Options',
  },
  {
    id: 3,
    imagePicture: nailImage,
    hText: 'Nailing Service',
    pText: 'Multiple Options',
  },
  {
    id: 4,
    imagePicture: makeupImage,
    hText: 'Make-Up Service',
    pText: 'Multiple Options',
  },
];

export const gymServices = [
  {
    id: 1,
    imagePicture: gymSingleImage,
    hText: '₦9,000.00',
    pText: '14 Days Subscription',
  },
  {
    id: 2,
    imagePicture: gymCoupleImage,
    hText: '₦16,000.00',
    pText: '14 Days Couple Subscription',
  },
  {
    id: 3,
    imagePicture: gymSingleImage,
    hText: '₦15,000.00',
    pText: 'Monthly Subscription',
  },
  {
    id: 4,
    imagePicture: gymCoupleImage,
    hText: '₦28,000.00',
    pText: 'Monthly Couple Subscription',
  },
  {
    id: 5,
    imagePicture: gymSingleImage,
    hText: '₦40,000.00',
    pText: 'Quarterly Subscription',
  },
  {
    id: 6,
    imagePicture: gymCoupleImage,
    hText: '₦75,000.00',
    pText: 'Quarterly Couple Subscription',
  },
];

export const apartments = [
  {
    id: 1,
    imagePicture: apartmentImage1,
    price: 50000,
    name: 'Studio Apartment',
    pageRoute: 'one-bedroom-suite',
    pText: "Our One Bedroom Suite is perfect for solo travelers or couples seeking a cozy and intimate setting. This suite features a spacious living area, a fully equipped kitchen, and a comfortable bedroom with a plush king-sized bed."
  },
  {
    id: 2,
    imagePicture: apartmentImage2,
    price: 80000,
    name: 'Standard One Bedroom Suite',
    pageRoute: 'executive-one-bedroom-suite',
    pText: "The Executive One Bedroom Suite offers a luxurious living experience with added space and upgraded amenities. Ideal for business travelers, this suite includes a dedicated workspace, a lavish bedroom, and a gourmet kitchen."
  },
  {
    id: 3,
    imagePicture: apartmentImage3,
    price: 90000,
    name: 'Business One Bedroom Suite',
    pageRoute: 'two-bedroom-apartment',
    pText: "Designed for families or groups, the Two Bedroom Apartment offers ample space and comfort. With two well-appointed bedrooms, a large living area, and a modern kitchen, this apartment is perfect for longer stays."
  },
  {
    id: 4,
    imagePicture: apartmentImage4,
    price: 120000,
    name: 'Deluxe Two Bedroom Apartment',
    pageRoute: 'three-bedroom-apartment',
    pText: "Our Three Bedroom Apartment is the epitome of luxury living. With three spacious bedrooms, a grand living room, and a state-of-the-art kitchen, this apartment provides the ultimate home-away-from-home experience."
  },
  {
    id: 5,
    imagePicture: apartmentImage1,
    price: 150000,
    name: 'Executive Three Bedroom Apartment',
    pageRoute: 'one-bedroom-suite',
    pText: "Our One Bedroom Suite is perfect for solo travelers or couples seeking a cozy and intimate setting. This suite features a spacious living area, a fully equipped kitchen, and a comfortable bedroom with a plush king-sized bed."
  },
  {
    id: 6,
    imagePicture: apartmentImage5,
    price: 180000,
    name: 'Luxury Two Bedroom Apartment with Cinema',
    pageRoute: 'deluxe-studio',
    pText: "The Deluxe Studio combines style and convenience in a compact yet luxurious setting. Ideal for short stays, this studio features a comfortable sleeping area, a kitchenette, and a stylish bathroom."
  },
];

export const rooms = [
  {
    id: 1,
    imagePicture: basicStandardImage,
    hText: '₦35,000.00',
    pText: 'Basic Standard',
    pageRoute: '/rooms-and-suites/basic-standard'
  },
  {
    id: 2,
    imagePicture: basicDeluxeImage,
    hText: '₦40,000.00',
    pText: 'Basic Deluxe',
    pageRoute: '/rooms-and-suites/basic-deluxe'
  },
  {
    id: 3,
    imagePicture: luxuryRegularImage,
    hText: '₦50,000.00',
    pText: 'Luxury Regular',
    pageRoute: '/rooms-and-suites/luxury-regular'
  },
  {
    id: 4,
    imagePicture: luxuryStandardImage,
    hText: '₦55,000.00',
    pText: 'Luxury Standard',
    pageRoute: '/rooms-and-suites/luxury-standard'
  },
  {
    id: 5,
    imagePicture: luxuryDeluxeImage,
    hText: '₦60,000.00',
    pText: 'Luxury Deluxe',
    pageRoute: '/rooms-and-suites/luxury-deluxe'
  },
];

export const sliderImages = [
  {
    id: 1,
    imageUrl: heroBg1
  },
  {
    id: 2,
    imageUrl: heroBg2
  },
  {
    id: 3,
    imageUrl: heroBg3
  },
  {
    id: 4,
    imageUrl: heroBg4
  },
]


export const sliderGalleryImages = [
  [
    {
      id: 1,
      imageUrl: galleryHeroImage
    },
    {
      id: 2,
      imageUrl: apartmentHeroImage
    },
    {
      id: 3,
      imageUrl: galleryHeroImage
    },
    {
      id: 4,
      imageUrl: apartmentHeroImage
    },
  ],
  [
    {
      id: 1,
      imageUrl: apartmentHeroImage
    },
    {
      id: 2,
      imageUrl: galleryHeroImage
    },
    {
      id: 3,
      imageUrl: galleryHeroImage
    },
    {
      id: 4,
      imageUrl: apartmentHeroImage
    },
  ],
]

export const moreThanSlides = [
  {
    id: 1,
    imageUrl: arenaImage,
    slide: 'WosAm Arena'
  },
  {
    id: 2,
    imageUrl: cinemaImage,
    slide: 'WosAm Cinema'
  },
  {
    id: 3,
    imageUrl: cafeImage,
    slide: 'WosAm Cafe'
  },
  // {
  //   id: 4,
  //   imageUrl: cafeImage,
  //   slide: 'WosAm Cafe'
  // },
  // {
  //   id: 4,
  //   imageUrl: cafeImage,
  //   slide: 'WosAm Cafe'
  // },
  
]

export const amenities = [
  {
    id: 1,
    imageUrl: amenitiesIcon1,
    hText: 'Airport Pick Up/Drop Off',
    pText: 'Start and end your journey stress-free with our reliable airport transfer service.',
  },
  {
    id: 2,
    imageUrl: amenitiesIcon2,
    hText: 'Gym Service',
    pText: 'Stay fit and healthy during your stay with access to our fully equipped gym.',
  },
  {
    id: 3,
    imageUrl: amenitiesIcon3,
    hText: 'Swimming Pool',
    pText: 'Unwind and relax in our beautifully designed swimming pool.',
  },
  {
    id: 4,
    imageUrl: amenitiesIcon4,
    hText: 'Fully Equipped Kitchen',
    pText: 'Each apartment comes with a modern kitchen, complete with all the appliances you need to prepare your favorite meals.',
  },
  
  
]

export const values = [
  {
    id: 1,
    imageUrl: valueIcon1,
    hText: 'EXCELLENCE',
    pText: 'We are committed to delivering the highest quality in every aspect of our services, from our thoughtfully designed apartments to our exceptional customer service.',
  },
  {
    id: 2,
    imageUrl: valueIcon2,
    hText: 'INTEGRITY',
    pText: 'Transparency and honesty are at the core of our operations. We believe in building lasting relationships with our guests based on trust.',
  },
  {
    id: 3,
    imageUrl: valueIcon3,
    hText: 'INNOVATION',
    pText: 'We continually seek new ways to enhance our guests’ experience by incorporating modern amenities and adopting the latest technologies.',
  },
  {
    id: 4,
    imageUrl: valueIcon4,
    hText: 'SECURITY',
    pText: 'We have equipped WosAm Luxury Apartments with the latest and most robust security technologies to ensure the safety of our guests.',
  },
]
export const lagos = [
  {
    id: 1,
    imageUrl: ikejaImage1,
    hText: 'Explore Local Cuisine',
    pText: "Ikeja GRA is home to a variety of top-rated restaurants and cafes, offering everything from traditional Nigerian dishes to international cuisine. Whether you're in the mood for fine dining or a casual meal, you'll find plenty of options to satisfy your taste buds.",
  },
  {
    id: 2,
    imageUrl: ikejaImage2,
    hText: 'Visit the Kalakuta Museum',
    pText: "For those interested in Nigerian history and culture, the Kalakuta Museum is a must-visit. This former home of the legendary musician and activist Fela Kuti now serves as a museum dedicated to his life and legacy. Visitors can explore his personal belongings, artwork, and even some of his iconic stage outfits.",
  },
  {
    id: 3,
    imageUrl: ikejaImage3,
    hText: 'Relax at Ikeja City Mall',
    pText: "For a more modern experience, Ikeja City Mall is the go-to destination for shopping, dining, and entertainment. With a wide range of shops, a cinema, and various eateries, it's a great place to spend a leisurely day.",
  },
  {
    id: 4,
    imageUrl: ikejaImage4,
    hText: 'Enjoy a Night Out',
    pText: "Ikeja GRA is known for its vibrant nightlife. From upscale bars and lounges to lively nightclubs, there's always something happening after dark. Whether you're looking to dance the night away or enjoy a quiet drink, you'll find a venue that suits your style.",
  }, 
]


export const abuja = [
  {
    id: 1,
    imageUrl: abujaImage1,
    hText: 'Visit Zuma Rock',
    pText: "Zuma Rock is one of Nigeria’s most iconic natural landmarks, often referred to as the Gateway to Abuja from Suleja. Standing majestically at 725 meters above sea level, this impressive granite formation is a must-see for anyone visiting Dawaki.",
  },
  {
    id: 2,
    imageUrl: abujaImage2,
    hText: 'Explore Nike Art Gallery',
    pText: "Although the original Nike Art Gallery is located in Lagos, Abuja boasts several art spaces and galleries that showcase local and contemporary African art. Dawaki is home to some vibrant art studios where creativity thrives.",
  },
  {
    id: 3,
    imageUrl: abujaImage3,
    hText: 'Visit Jabi Lake',
    pText: "Jabi Lake is a serene and picturesque spot located close to Dawaki, perfect for relaxation and recreational activities. The lake area is a favorite among locals and tourists alike.",
  },
  {
    id: 4,
    imageUrl: abujaImage4,
    hText: 'Shop at the Dawaki Modern Market',
    pText: "Dawaki Modern Market is the heartbeat of the suburb’s commercial activity, offering a vibrant shopping experience for residents and visitors.",
  }, 
]


export const ogun = [
  {
    id: 1,
    imageUrl: ogunImage1,
    hText: 'Visit Olumo Rock',
    pText: "While not located directly in Ago-Iwoye, a short trip to Abeokuta will take you to Olumo Rock, one of Nigeria's most famous landmarks. This historic site offers breathtaking views of the surrounding landscape and insight into the history of the Egba people.",
  },
  {
    id: 2,
    imageUrl: ogunImage2,
    hText: 'Explore Local Markets',
    pText: "Experience the vibrant local culture by visiting one of the traditional markets in Ago-Iwoye. Here, you can shop for fresh produce, handmade crafts, and traditional fabrics while interacting with friendly locals.",
  },
  {
    id: 3,
    imageUrl: ogunImage3,
    hText: 'Visit the Olabisi Onabanjo University',
    pText: "Take a stroll around the campus of Olabisi Onabanjo University, a key institution in the region. The university grounds are peaceful and well-maintained, providing a pleasant environment for a leisurely walk.",
  },
  {
    id: 4,
    imageUrl: ogunImage4,
    hText: 'Enjoy the Local Cuisine',
    pText: "Ago-Iwoye offers a range of local dining experiences where you can enjoy traditional Yoruba dishes. From street food vendors to small eateries, you'll find authentic flavors that reflect the region's culinary heritage.",
  }, 
]


export const bookingBgImages = [
  {
    id: 1,
    imageUrl: bookingImage
  },
  {
    id: 2,
    imageUrl: bookingImage2,
  },
  {
    id: 3,
    imageUrl: bookingImage3,
  },
]

